export const SWIFT_FULFILLMENT = 'Smartcard';
export const MTICKET_FULFILLMENT = 'mTicket';
